import { useAnnouncer } from './announcer';

export function LiveRegion() {
  const message = useAnnouncer((s) => s.message);
  const key = useAnnouncer((s) => s.key);
  return (
    <div className="visually-hidden" role="status" aria-live="polite" aria-atomic="true">
      <span key={key}>{message}</span>
    </div>
  );
}
